import {autocompleteEvkOption, EvkFormComponentBase, EvkOption} from '@evomatik/evk-common';
import {EvkSecurityControlDataService} from '@evomatik/evk-seguridad';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {filter, map, startWith} from 'rxjs/operators';
import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {TareaDocumentoModel} from "../../../../../../../diligencia/models/tarea-documento.model";
import {EvkDiligenciaConfigModel} from "../../../../../../../diligencia/models/diligencia-config.model";
import {CatalogosService} from "../../../../../../../expediente/services/catalogos.service";
import { DiligenciaTareaModel } from '../../../../../../../diligencia/models/diligencia-tarea.model';

@Component({
    selector: 'evk-solicitar-autorizacion-create-form',
    templateUrl: './solicitar-autorizacion-create-form.component.html',
    styleUrls: ['./solicitar-autorizacion-create-form.component.scss']
})
export class SolicitarAutorizacionCreateFormComponent extends EvkFormComponentBase<TareaDocumentoModel> implements OnInit {

    tiposOrganizacionOptions: EvkOption[] = [];
    organizacionesOptions: EvkOption[] = [];
    usuariosOptions: EvkOption[] = [];

    organizacionesFilteredOptions$: Observable<EvkOption[]>;
    tiposOrganizacionFilteredOptions$: Observable<EvkOption[]>;
    usuariosFilteredOptions$: Observable<EvkOption[]>;

    @Input()
    public diligencia: DiligenciaTareaModel;

    @Input()
    public diligenciaConfig: EvkDiligenciaConfigModel;

    form: FormGroup;

    constructor(public fb: FormBuilder,
                public catalogoService: CatalogosService,
                private securityControlDataService: EvkSecurityControlDataService) {
        super(fb);
    }

    ngOnInit() {
        super.ngOnInit();
        this.cargarCatalogos();
        this.eventHandlerEventInit();
    }

    protected get formBuild(): FormGroup {
        return this.fb.group({
            tipoOrganizacion: [null, [Validators.required, autocompleteEvkOption]],
            organizacion: [null, [Validators.required, autocompleteEvkOption]],
            usuarioAsignado: [null, [autocompleteEvkOption]]
        });
    }

    eventHandlerEventInit() {
        this.tiposOrganizacionFilteredOptions$ = this.form.controls.tipoOrganizacion.valueChanges
            .pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                map(name => name ? this._filter(name, this.tiposOrganizacionOptions) : this.tiposOrganizacionOptions.slice()),
            );

        this.organizacionesFilteredOptions$ = this.form.controls.organizacion.valueChanges
            .pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                map(name => name ? this._filter(name, this.organizacionesOptions) : this.organizacionesOptions.slice()),
            );

        this.usuariosFilteredOptions$ = this.form.controls.usuarioAsignado.valueChanges
            .pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                map(name => name ? this._filter(name, this.usuariosOptions) : this.usuariosOptions.slice()),
            );
    }

    public cargarCatalogos() {
        if (this.diligencia.estadoTareaActivo.estado.nombre === 'EN CORRECCIÓN' ||
            this.diligencia.estadoTareaActivo.estado.nombre === 'POR AUTORIZAR' ||
            this.diligencia.estadoTareaActivo.estado.nombre === 'CREADA') {
            this.tiposOrganizacionOptions = this.diligenciaConfig.tipoOrganizacionAutorizador;
            this.precargaTipoOrganizacion();
        } else if (this.diligencia.tarea.estadoTareaActivo.estado.nombre === 'EN AUTORIZACIÓN') {
            this.cargarTiposOrganizaciones();
            this.precargaTipoOrganizacion();
        } else {
            alert('cargar otra configuracion');
        }
    }

    precargaTipoOrganizacion() {
        const tipoOrganizacion = {
            label: localStorage.getItem('tipoOrganizacion'),
            value: localStorage.getItem('tipoOrganizacionId')
        };
        const organizacion = {label: localStorage.getItem('unidad'), value: localStorage.getItem('unidadId')};
        if (this.tiposOrganizacionOptions.some(opt => opt.value === tipoOrganizacion.value)) {
            this.form.controls['tipoOrganizacion'].patchValue(tipoOrganizacion);
            this.cargaOrganizacionesByTipo(tipoOrganizacion);
            this.form.controls['organizacion'].patchValue(organizacion);
            this.cargarUsuarios(organizacion);
        }
    }

    cargarTiposOrganizaciones() {
        const organizacionOrigen = this.securityControlDataService.getUsuarioInfo() && this.securityControlDataService.getUsuarioInfo().orgLogica ?
            this.securityControlDataService.getUsuarioInfo().orgLogica :
            this.securityControlDataService.getUsuarioInfo().orgFisica;
        this.resetOptionsUsuarioAsignado();
        this.catalogoService.getTiposOrganizacionesByOrganizacionOrigenAndTipoConfiguracion(organizacionOrigen['value'], 'AUTORIZACION').subscribe(usuarios => {
            this.tiposOrganizacionOptions = usuarios;
        });

    }

    cargaOrganizacionesByTipo(tipoOrganizacion: EvkOption) {
        this.resetOptionsOrganizaciones();
        if (tipoOrganizacion.value !== null) {
            this.catalogoService.getOrganizacionesByTipoOrganizacion(tipoOrganizacion.value).subscribe(organizaciones => {
                this.organizacionesOptions = organizaciones;
            });
        }
    }

    cargarUsuarios(organizacion) {
        this.resetOptionsUsuarioAsignado();
        if (organizacion.value !== null) {
            this.catalogoService.getUsuariosForUnidadOrganizacional(organizacion.value, ['AUTORIZADOR']).subscribe(usuarios => {
                const usuarioFiltroUno = usuarios.filter(usuario => usuario.label !== localStorage.getItem('nombreCompleto'));
                for (const prop in usuarioFiltroUno) {
                    if (this.diligencia.usuarioDestino) {
                        if (usuarioFiltroUno[prop] === this.diligencia.usuarioDestino.value) {
                            usuarioFiltroUno.splice(parseInt(prop, 10), 1);
                        }
                    }
                }
                this.usuariosOptions = usuarioFiltroUno;
            });
        }
    }

    cleanValuesTipoOrganizacion(event$: any) {
        if (event$.target.value === '') {
            this.resetOptionsOrganizaciones();
        }
    }

    cleanValuesOrganizaciones(event$: any) {
        if (event$.target.value === '') {
            this.resetOptionsUsuarioAsignado();
        }
    }

    resetOptionsOrganizaciones() {
        this.organizacionesOptions = [];
        this.usuariosOptions = [];
        this.resetValues(['organizacion', 'usuarioAsignado']);
    }

    resetOptionsUsuarioAsignado() {
        this.usuariosOptions = [];
        this.resetValues(['usuarioAsignado']);
    }

    resetValues(nameControls: string[]) {
        nameControls.forEach(value => {
            this.form.controls[value].setValue('');
        });
    }

}
